import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Form,
  Image,
  OverlayTrigger,
  Row,
  Spinner,
  Stack,
  Tooltip,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import dockLogo from "../../images/dock.png";
import {
  getUserDetails,
  listUsers,
  mfaSettingToggle,
  updateUserProfile,
} from "../../redux/Actions/userAction";
import Loader from "../../components/Loader";
import Message from "../../components/Message";
import {
  faDownload,
  faInfoCircle,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { message } from "antd";
import { Switch } from "@mui/material";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { getUserAgreement } from "../../redux/slices/clientSlice";
import moment from "moment";
import html2pdf from "html2pdf.js";

const ClientProfilePage = () => {
  const userInfo = useSelector((state) => state.userDetails);
  const { loading, error, user } = userInfo;
  const {
    loading: updateLoading,
    success: updateSuccess,
    error: updateError,
  } = useSelector((state) => state.userUpdate);

  const dispatch = useDispatch();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordMatch, setPasswordMatch] = useState(false);

  const [checked, setChecked] = React.useState(user?.isMFAEnabled);
  const [toggleLoading, setToggleLoading] = useState(false);
  const [agreement, setAgreement] = useState(null);

  const submiHandler = (e) => {
    e.preventDefault();
    if (password == confirmPassword) {
      setPasswordMatch(false);
      const updatedUser = {
        name,
        email,
        password,
      };
      dispatch(updateUserProfile(updatedUser));
      setPassword("");
      setConfirmPassword("");
    } else {
      setPasswordMatch(true);
    }
  };

  const handleMFAToggle = (event) => {
    setToggleLoading(true);
    const payload = {
      userId: user?._id,
      isRoleUser: user?.isRoleUser,
      enableMFA: event?.target?.checked,
    };
    dispatch(mfaSettingToggle(payload))
      .then((result) => {
        if (result?.success) {
          setChecked(result.isMFAEnabled);
          message.success(
            result?.message ?? "MFA setting updated successfully"
          );
        }
      })
      .catch((err) => {
        message.error("Failed to update MFA setting");
      })
      .finally(() => setToggleLoading(false));
  };

  // const handleDownloadAgreement = async () => {
  //   try {
  //     // setAgreementDownlaoding(true);
  //     message.loading("Preparing agreement...", 0);

  //     // Fetch using Redux thunk
  //     const fetchedAgreement = await dispatch(getUserAgreement()).unwrap();
  //     if (!fetchedAgreement) {
  //       message.destroy();
  //       // setAgreementDownlaoding(false);
  //       return message.error("No service agreement found");
  //     }

  //     // Set into state (so the hidden div updates)
  //     setAgreement(fetchedAgreement);

  //     // Wait for React to re-render before snapshot
  //     setTimeout(() => {
  //       const element = document.getElementById("agreement-pdf");
  //       if (!element) return;

  //       const options = {
  //         margin: 10,
  //         filename: `${fetchedAgreement.title || "ServiceAgreement"}.pdf`,
  //         image: { type: "jpeg", quality: 0.98 },
  //         html2canvas: { scale: 2 },
  //         jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
  //       };

  //       html2pdf()
  //         .set(options)
  //         .from(element)
  //         .save()
  //         .then(() => {
  //           message.destroy();
  //           message.success("Service Agreement downloaded successfully");
  //           // setAgreementDownlaoding(false);
  //         })
  //         .catch(() => {
  //           message.destroy();
  //           message.error("Failed to download Service Agreement");
  //           // setAgreementDownlaoding(false);
  //         });
  //     }, 300);
  //   } catch (err) {
  //     console.error(err);
  //     message.destroy();
  //     message.error("Failed to download agreement");
  //     // setAgreementDownlaoding(false);
  //   }
  // };

  const handleDownloadAgreement = async () => {
    try {
      message.loading("Preparing agreement", 0);

      const fetchedAgreement = await dispatch(getUserAgreement()).unwrap();
      if (!fetchedAgreement) {
        message.destroy();
        return message.error("No service agreement found");
      }

      const htmlContent = `
        <div style="font-family: Arial, sans-serif; padding: 20px;">
          <h2 style="text-align: center; margin-bottom: 16px;">
            ${fetchedAgreement.title || "Service Agreement"}
          </h2>
  
          ${
            fetchedAgreement?.content?.recitals
              ? `<h4>Recitals</h4><p>${fetchedAgreement.content.recitals}</p>`
              : ""
          }  
          ${
            fetchedAgreement?.content?.articles
              ?.map(
                (article, i) => `
              <h5 style="margin-top: 12px;">${i + 1}. ${article.title}</h5>
              <p>${article.body}</p>
            `
              )
              .join("") || ""
          }  
          ${
            fetchedAgreement?.content?.acceptance
              ? `<h4>Acceptance</h4><p>${fetchedAgreement.content.acceptance}</p>`
              : ""
          }  
          <hr style="margin-top: 24px;" />
          <div style="margin-top: 16px;">        
            <p><strong>Accepted By:</strong> ${
              fetchedAgreement?.signedBy || ""
            }</p>
            <p><strong>Email:</strong> ${
              fetchedAgreement?.signeeEmail || ""
            }</p>
              <p><strong>Accepted On:</strong> ${
                moment(fetchedAgreement.agreedAt) || ""
              }</p>
           
          </div>
        </div>
      `;

      const options = {
        margin: 10,
        filename: `${fetchedAgreement.title || "ServiceAgreement"}.pdf`,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      };

      await html2pdf().set(options).from(htmlContent).save();

      message.destroy();
      message.success("Download successful");
    } catch (err) {
      console.error(err);
      message.destroy();
      message.error("Failed to download agreement");
    }
  };

  useEffect(() => {
    let hideLoading;
    if (updateLoading) {
      hideLoading = message.loading("Updating", 0);
    }
    if (updateSuccess) {
      if (hideLoading) hideLoading();
      message.success("Updated!");
    }
    if (updateError) {
      if (hideLoading) hideLoading();
      message.error(updateError || "Failed to update");
    }
    return () => {
      if (hideLoading) hideLoading();
    };
  }, [updateLoading, updateSuccess, updateError]);

  useEffect(() => {
    dispatch(getUserDetails());
  }, [dispatch]);

  useEffect(() => {
    if (user) {
      setName(user.companyName);
      setEmail(user.email);
    }
  }, [user]);

  const styles = {
    shadow: {
      boxShadow:
        " rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    },
  };

  return (
    <>
      <Row className="h-100 mt-md-5 p-3 gap-3 justify-content-center">
        <Col
          md={3}
          xs={12}
          style={styles.shadow}
          className="border border-1 rounded-3 px-2 py-5 mx-3"
        >
          <Row className="justify-content-center">
            {user && user.isSuperAdmin ? (
              <Col sm={7}>
                <Image src={dockLogo} alt="Dock" roundedCircle fluid />
              </Col>
            ) : (
              <Col xs="auto" className="border border-1 p-5 rounded-circle">
                <FontAwesomeIcon
                  icon={faUser}
                  size="4x"
                  className="text-primary"
                />
              </Col>
            )}
          </Row>
          <Row className="my-3">
            <h4 className="text-center text-break m-0">{name}</h4>
            <span className="text-center text-muted text-break">{email}</span>
          </Row>
        </Col>
        <Col
          md={8}
          xs={12}
          style={styles.shadow}
          className="border border-1 rounded-3"
        >
          <Card border="0">
            <Card.Body>
              <div className="px-3">
                <Card.Title className="text-center text-muted">
                  Edit Details
                </Card.Title>
              </div>
              <hr />
              <Row>
                {updateError && <Message>{updateError}</Message>}
                <Form onSubmit={submiHandler}>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Company Name</Form.Label>
                        <Form.Control
                          type="text"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                          type="text"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <h5 className="my-3 text-muted">Change Password</h5>
                  <Row>
                    <Form.Group className="mb-3" controlId="formBasicPassword">
                      <Form.Label>New Password</Form.Label>
                      <Form.Control
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formBasicPassword">
                      <Form.Label>Confirm New Password</Form.Label>
                      <Form.Control
                        type="password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                      />
                      {password != confirmPassword && confirmPassword != "" ? (
                        <Form.Text className="text-danger">
                          Passwords does not match
                        </Form.Text>
                      ) : (
                        <></>
                      )}
                    </Form.Group>
                  </Row>
                  <Row>
                    <Col sm="auto" className="ms-auto">
                      <Button variant="success" type="submit">
                        Save Changes
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Row>
              <hr />
              <Row>
                <Card.Title className="text-muted">
                  Additional Settings
                </Card.Title>
                <Form>
                  <Form.Group as={Row} className="align-items-center mb-2">
                    <Form.Label column sm="8" className="mb-0">
                      Two-Factor Authentication{" "}
                      <OverlayTrigger
                        placement="right"
                        overlay={
                          <Tooltip>
                            Adds extra login protection using a one-time code
                            sent to your email.
                          </Tooltip>
                        }
                      >
                        <span
                          className="text-muted"
                          style={{ cursor: "pointer" }}
                        >
                          <FontAwesomeIcon icon={faInfoCircle} />
                        </span>
                      </OverlayTrigger>
                    </Form.Label>

                    <Col sm="4">
                      <Stack
                        direction="horizontal"
                        gap={1}
                        className="justify-content-end"
                      >
                        <Form.Check
                          type="switch"
                          id="mfa-toggle-switch"
                          checked={checked}
                          onChange={handleMFAToggle}
                          disabled={toggleLoading}
                        />
                        {toggleLoading && (
                          <Spinner animation="border" size="sm" />
                        )}
                      </Stack>
                    </Col>
                  </Form.Group>
                </Form>
              </Row>
              <Row>
                <Col className="ms-auto">
                  <span
                    className="text-muted fs-7"
                    style={{ cursor: "pointer" }}
                    onClick={handleDownloadAgreement}
                  >
                    Download Service Agreement{" "}
                    <FontAwesomeIcon icon={faDownload} />{" "}
                  </span>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default ClientProfilePage;
